// Unique id created for every user or every app load
// We use this id as a unique identifier of a user in
// address autosuggest call to maintain a session for
// requests to address suggestion feature
const SESSION_ID =
  Date.now().toString(36) + Math.random().toString(36).substr(2, 5);

// `country` is not part of this list since it's not treated as part of the
// shipping/billing address
const SHIPPING_AND_CALLBACK_ADDRESS_FIELDS = new Set([
  'city',
  'state',
  'postalcode',
]);

const ADDRESS_TYPES = {
  BILLING_ADDRESS: 'billingAddress',
  RESIDENTIAL_ADDRESS: 'residentialAddress',
  SHIPPING_ADDRESS: 'shippingAddress',
};

export { ADDRESS_TYPES, SESSION_ID, SHIPPING_AND_CALLBACK_ADDRESS_FIELDS };
